import * as React from "react";
import Component from "../../AbstractComponent";
import Constants from "../../../Action/Constants";
import { connect } from "react-redux";
import { Link } from "react-router";
import SignupActions from "../../../Action/Actions/SignupActions";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import TextField from "../../Partials/Material/TextField";
import Button from '@material-ui/core/Button';
import Translator from "../../../Translation/Translator";

class Signup extends Component {
  protected shouldClearBeforeUnmounting: boolean = true;
  protected clearWith: string = Constants.PAGE_SIGNUP_CLEAR;
  // TODO fix hardcoded values
  protected languageId: number = 2;

  public state = {
    isInitiallySubmitted: false,
    isChecked: false,
    errorTermsCheckbox: false,
    isConfirmPasswordDialogOpen: false,
    isEmailNotValid: false,
  };

  constructor(public props) {
    super(props);

    const lngParameter = parseInt(this.props.location?.query?.lng);
    // TODO fix hardcoded values
    if (lngParameter === 1 || lngParameter === 2) {
      Translator.use(lngParameter === 1 ? "en-US" : "nl-NL");
      this.languageId = lngParameter;
    }
  }

  /**
   * This is the hotfix for react-router issue, that cause the problem of
   * infinite rerendering of component: routeParams(received for react-router Route) props
   * updates few times per sec
   * 
   * TODO: Should be fixed by installing the new version of react-router-dom
   * */ 
  shouldComponentUpdate(newProps, nextState) {
    if (this.state !== nextState) return true;

    const isPropsStringsSame = JSON.stringify(newProps) === JSON.stringify(this.props)
    if (
      isPropsStringsSame
      && newProps.routeParams !== this.props.routeParams
    ) {
      return false;
    }

    return !isPropsStringsSame;
  }

  protected onEnter = (event): any => {
    if (event.key === "Enter") {
      return this.process();
    }
  }

  protected process = () =>  {
    if (!this.state.isChecked) {
      return this.setState({
        errorTermsCheckbox: true
      })
    }
    const data = {
     company: {
        name: this.props.signup.company.name,
        email: this.props.signup.email,
        lng: this.languageId
      },
      contact: {
        firstName: this.props.signup.contact.firstName,
        lastName: this.props.signup.contact.lastName,
        email: this.props.signup.email
      }
    };

    this.setState({isInitiallySubmitted: true});
    this.props.dispatch(
      SignupActions.start(data, [
        {
          field: "company.name",
          value: this.props.signup.company.name
        },
        {
          field: "company.email",
          value: this.props.signup.email
        },
        {
          field: "contact.firstName",
          value: this.props.signup.contact.firstName
        },
        {
          field: 'contact.lastName',
          value: this.props.signup.contact.lastName
        }
      ], () => {
        this.setState({
          isConfirmPasswordDialogOpen: true
        })
      }, () => {
        this.setState({
          isEmailNotValid: true,
        })
      })
    );
  }

  protected updateCompany = (e) => {
    this.props.dispatch(SignupActions.updateCompany(e.target.value));
  }

  protected updateEmail = (e) => {
    this.props.dispatch(SignupActions.updateEmail(e.target.value));
  }

  protected updateContact = ({target: {name, value}}) => {
    this.props.dispatch(SignupActions.updateContact({[name]: value}));
  }

  protected hasError = (object: string, field: string): boolean => {
    if (!this.state.isInitiallySubmitted) return false;

    let signupField;
    if (object === 'null' && field === 'email') {
      signupField = this.props.signup.email;
    } else {
      signupField = this.props.signup[object][field];
    }

    return !!signupField ? !signupField.length : true;
  }

  public switchIsChecked = () => {
    this.setState({
      isChecked: !this.state.isChecked,
      errorTermsCheckbox: false
    });
  }

  public renderSuccessInfo = () => {
    return (
      <div style={{display: "flex", flexDirection: "column", textAlign: 'center'}}>
        <div className="image-container" style={{display: "flex", justifyContent: "center"}}>
          {this.image.getAvatar("success", { size: 62 })}
        </div>

        <div className="main-text-of-step" style={{margin: "20px 0 -5px 0"}}>
          {this.trans("success")}
        </div>

        <div className="info-text-gray">
          {this.trans("page/singup-dialog/confirmpassword", {email: this.props.signup.email})}
        </div>
        <div className="info-text-gray">
          {this.trans("page/singup-dialog/confirmpassword-2")}
        </div>
      </div>
    );
  }

  public render() {
    return (
      <div className="state-auth">
        <div className="box component-signup">
          {
            this.state.isConfirmPasswordDialogOpen && this.renderSuccessInfo()
          }

          {
            !this.state.isConfirmPasswordDialogOpen && 
            <React.Fragment>
              <div style={{textAlign: "center"}}>
                <h1>Casadesk</h1>

                <div className="main-text-of-step" style={{margin: "5px 0 -10px 0"}}>
                  {this.trans("signup/main-text")}
                </div>
                
                <div className="info-text-gray">
                  {this.trans("signup/info-text")}
                </div>
              </div>

              <form>
                <TextField
                  className="form-element-signup"
                  value={this.props.signup.company.name}
                  onChange={this.updateCompany}
                  label={this.trans("label-sign-up-page-agency-name")}
                  id="agency_name"
                  type="text"
                  fullWidth={true}
                  onKeyPress={this.onEnter}
                  autoFocus={true}
                  variant="standard"
                  error={this.hasError('company','name') ? !!this.props.signup.message : false}
                />
                {this.hasError('company','name') && <div className="component-error-text-auth">{this.props.signup.message}</div>}

                <TextField
                  className="form-element-signup"
                  value={this.props.signup.email}
                  onChange={this.updateEmail}
                  label={this.trans("label-user-email")}
                  id="email"
                  type="email"
                  fullWidth={true}
                  onKeyPress={this.onEnter}
                  variant="standard"
                  error={!!this.getErrorFor("contact.email")}
                />
                {this.state.isEmailNotValid && <div className="component-error-text" style={{ marginTop: "5px" }}>{this.trans("this-field-is-not-valid")}</div>}

                <TextField
                  className="form-element-signup"
                  value={this.props.signup.contact.firstName}
                  onChange={this.updateContact}
                  label={this.trans("label-your-first-name")}
                  id="first_name"
                  name="firstName"
                  type="text"
                  fullWidth={true}
                  onKeyPress={this.onEnter}
                  variant="standard"
                  error={this.hasError('contact','firstName') === true ? !!this.props.signup.message : false}
                />
                {this.hasError('contact','firstName') && <div className="component-error-text-auth">{this.props.signup.message}</div>}

                <TextField
                  className="form-element-signup"
                  value={this.props.signup.contact.lastName}
                  onChange={this.updateContact}
                  label={this.trans("label-last-name")}
                  id="last_name"
                  type="text"
                  name="lastName"
                  fullWidth={true}
                  onKeyPress={this.onEnter}
                  variant="standard"
                  error={this.hasError('contact', 'lastName') === true ? !!this.props.signup.message : false}
                />
                {this.hasError('contact', 'lastName') && <div className="component-error-text-auth">{this.props.signup.message}</div>}

                <div className="component-signup-terms-wrapper">
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.isChecked}
                        onChange={this.switchIsChecked}
                        color="primary"
                        className={`${this.state.errorTermsCheckbox ? "error-checkbox" : ""}`}
                        />
                      }
                    label={""}
                  />
                  <span>
                    {Translator.transJSX("pages/singup-info/termsandconditionstext", {
                      terms:
                        <span className="underline" onClick={() => {
                          window.open("https://www.casadesk.com/conditions-nl", "_blank")}}>
                          {this.trans("terms-link")}</span>,
                          agreement: <span className="underline" onClick={() => {window.open("https://www.casadesk.com/dataprocessing-nl", "_blank")}}>{this.trans("processing-agreement-link")}</span> })}
                  </span>
                </div>
                {this.state.errorTermsCheckbox && <div className="component-error-text-auth" style={{marginLeft: "13px"}}>{this.trans("this-field-is-required")}</div>}

                <Button
                  variant="contained"
                  color="primary"
                  fullWidth={true}
                  onClick={this.process}
                  disabled={this.props.signup.isFetching}
                  style={{ margin: "20px 0"}}
                >
                  {this.props.signup.isFetching === true ? this.trans("button-please-wait") : this.trans("button-signup")}
                </Button>

                <span>{this.trans("link-go-to-signin")} <Link to="/auth/check-email">{this.trans("link-go-to-signin-underscore")}</Link></span>
              </form>
            </React.Fragment>
          }
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    signup: state.signup,
    globalTypes: state.globalTypes
  };
};

export default connect(mapStateToProps)(
  Signup
);
